import React, { useState, FC } from "react";
import cn from "clsx";
import { css } from "linaria";

import ErrorBGAsset from "../../assets/images/NoArtifactBgAsset.jpg";
import ErrorCardAsset from "../../assets/images/NoArtifactCardAsset.jpg";

const fillStyles = css`
  bottom: 0;
  display: block;
  left: 50%;
  height: 100%;
  position: absolute;
  transform: translate3d(-50%, 0, 0);
  width: 100%;
`;

const backdropStyles = css`
  object-fit: cover;
  z-index: 0;
`;

const envelopeStyles = css`
  bottom: -1px;
  height: auto;
  left: 0;
  transform: translate3d(-2px, 0, 0);
  width: 60%;
  z-index: 1;
`;

const cardStyles = css`
  bottom: -1px;
  height: auto;
  width: 50%;
  z-index: 3;
`;

const LandscapeCardStyles = css`
  width: 65%;
`;

const shadowCSS = css`
  z-index: 2;
`;

interface Props {
  artifacts: any;
}

const CardsOnFlyerPreview: FC<Props> = ({ artifacts }) => {
  const [cardData, setCardData] = useState({
    height: 0,
    loaded: false,
    width: 0,
  });

  let cardArtifactData,
    srcBackdrop = ErrorBGAsset,
    srcCard = ErrorCardAsset,
    srcEnvelope,
    aspectRatioStyles;

  if (artifacts) {
    cardArtifactData = artifacts?.cardFront?.asset?.renditions?.pngSmall;

    // If the card artifact doesn't exist, we'll use error assets...
    if (cardArtifactData) {
      srcBackdrop =
        artifacts?.backdropDesktop?.asset?.renditions?.jpegSmall?.url;
      srcCard = cardArtifactData?.url;
      srcEnvelope = artifacts?.envelopeBack?.asset?.renditions?.pngSmall?.url;
      if (cardArtifactData.width && cardArtifactData.height) {
        aspectRatioStyles =
          cardArtifactData.width / cardArtifactData.height >= 1
            ? LandscapeCardStyles
            : undefined;
      }
    }
  }

  return (
    <div className="relative flex flex-col items-center justify-end overflow-hidden w-28 h-28">
      <img
        className={cn(fillStyles, cardStyles, aspectRatioStyles)}
        onLoad={(e) => {
          setCardData({
            height: e.currentTarget.clientHeight,
            loaded: true,
            width: e.currentTarget.clientWidth,
          });
        }}
        src={srcCard}
        alt="Invitation card front"
      />
      {srcEnvelope && (
        <img
          className={cn(fillStyles, envelopeStyles)}
          src={srcEnvelope}
          alt="Invitation envelope back"
        />
      )}
      {srcBackdrop && (
        <img
          className={cn(fillStyles, backdropStyles)}
          src={srcBackdrop}
          alt="Invitation backdrop"
        />
      )}
      {cardData.loaded && (
        <AnimatedShadow
          className={cn(fillStyles, cardStyles, shadowCSS, aspectRatioStyles)}
          height={cardData.height}
          width={cardData.width}
        />
      )}
    </div>
  );
};

interface ShadowProps {
  className?: string;
  height: number;
  width: number;
}

const AnimatedShadow: FC<ShadowProps> = ({ className, height, width }) => {
  const skewX = 3; // alternatively width * .05

  return (
    <svg
      className={className}
      viewBox={`-${skewX} 0 ${width + skewX} ${height}`}
      style={{
        height: `${height}px`,
        transform: `translate3d(calc(-50% - ${skewX / 2}px), 0, 0)`,
        width: `${width + skewX}px`,
      }}
    >
      <linearGradient id="CoFGradientID" gradientTransform="rotate(90)">
        <stop offset="0%" stopColor="rgba(0, 0, 0, 0.45)" />
        <stop offset="80%" stopColor="rgba(0, 0, 0, 0.15)" />
      </linearGradient>
      <polygon
        points={`0,0 ${width - Math.ceil(skewX)},0 ${
          width - Math.ceil(skewX)
        },${height} -${skewX},${height}`}
        preserveAspectRatio="none"
        fill="url('#CoFGradientID')"
      />
    </svg>
  );
};

export default React.memo(CardsOnFlyerPreview);
